import Layout from '../../internal/Layout.vue'
import ReferralAdminPage from './ReferralAdmin/referralAdmin.vue'

const IndicationRoutes = {
  component: Layout,
  children: [
    {
      name: 'referralAdmin',
      path: '/',
      component: ReferralAdminPage,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
      },
    },
  ],
}

export default IndicationRoutes
